module.exports = __webpack_public_path__ + "img/logo-beaulieu-258.de80b522.jpeg";